import React from 'react';
import Panel from '../../components/ui/Panel';
import EmptyState from '../../components/ui/EmptyState';
import Tag from '../../components/ui/Tag';
import { CATEGORY } from '../../components/ui/categoryColors';

const WorkOrderQueueModule = () => {
  return (
    <Panel title="Work Orders" titleStyle="section" accent="blue" level={3} actions={<Tag size="sm" hex={CATEGORY.blue.ink.hex}>Phase 11</Tag>}>
      <EmptyState variant="area" title="Coming in the manufacturing phase">Work order creation, tracking, and queue management</EmptyState>
    </Panel>
  );
};

export default WorkOrderQueueModule;
